<div fxFlex=100 fxFlex.lt-md=100 >
    <div>
            <div class="urlDiv" fxLayout="row wrap">
                <a class="urls" href="/userProfiles/{{userId}}?home=false">
                  Home /
                </a>
                <a  class="urls" href="/hitmaker">
                   &nbsp;Hitmaker /
                </a>
                <a  class="urls" href="/hitmaker/{{movieId}}">
                    &nbsp;{{movieName}}
                 </a>
                </div>
    <div class="videoInfo" fxLayout="row wrap" fxLayoutAlign="center" fxLayout.lt-md="column"
                fxLayoutAlign.lt-md="center center">
        <div class="top-section">
            <div class="movieBanner" fxLayout="column">
                <img class="imgMovie" [src]="bannerImageUrl">
            </div>
            <div class="movieDesc" fxLayout="column">
                <p class="moviename">{{movieName}} </p>   
                <br>         
                <div class="movieDesc_scrollable">
                        <div class="column" fxLayout="row wrap">
                        <p class="descriptionText" style="display:inline-block; margin: 0;">
                            Film Description: {{movieDesc}}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="flexBox" fxFlex="100%" fxLayout="row wrap" style="margin-top: 10px;">
            <h2 class="textDiscover" id="discover1"><b>{{heading}}</b>
            </h2>    
        </div>

        <div class="flexBox"
            fxLayout="row wrap"
            fxLayoutAlign="center start"
            fxLayout.lt-md="row wrap"
            fxLayout.xs="column">
    
            <div class="card"
               appTrackClick 
                [buttonProps]="{
                    title:'hitmaker_casting_stage',
                    feature_context:'HITMAKER'
                }"
            >
                <div class="card-text-div" (click)="getStageDetails('casting', $event)">
                  <a class="card-text" href="" style="text-decoration: none;">
                    <span style="color: white; font-size: 18px; padding: 0 10px;">Casting</span><br>
                    <span style="color: white; font-size: 14px; text-align: center;">Help discover the<br> next great movie star!</span>
                </a>
                </div>
              
                <div class="card-img-div" (click)="getStageDetails('casting', $event)">
                  <a href="">
                    <img class="card-content" height="100%" width="100%" [src]="showCastingThumbnailValue ? stage1Image : '/../../../../../../assets/images/hitmaker/1_Casting.jpg'">
                    <span class="numberCircle">1</span>
                  </a>
                </div>
              
                <div class="card-status-div">
                  <span style="font-style: 'Lato';">
                    {{ castingStatus }}
                  </span>
                </div>
            </div>
            
            <div class="card"
               appTrackClick 
                [buttonProps]="{
                    title:'hitmaker_pre-production_stage',
                    feature_context:'HITMAKER'
                }"
            >
                <div class="card-text-div">
                    <a class="card-text"  href="" (click)="getStageDetails('pre-production', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Pre-Production</span>
                        <br>
                        <span  style="color: white;font-size: 14px;text-align: center;">
                            Enjoy a show on your<br> star’s journey!</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('pre-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="100%"  [src]="showPreProductionThumbnailValue ? stage2Image : '/../../../../../../assets/images/hitmaker/2_PreProduction.jpg'" width="100%">
                            <span class="numberCircle">2</span>                       

                        </a>

                        
                </div>
                <div class="card-status-div">
                    <span style="font-style: 'Lato';">
                        {{preProductionStatus }}
                    </span>
                  </div>
            </div>
    
            <div class="card"    
            appTrackClick 
            [buttonProps]="{
                title:'hitmaker_filming_stage',
                feature_context:'HITMAKER'
            }">
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('filming', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Filming</span>
                        <br>
                        <span style="color: white;font-size: 14px;
                        text-align: center;">  Enter the exciting  world <br> of production!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('filming', $event)">
                        <a href="">
                            <img class="card-content" height="100%" [src]="showFilmingThumbnailValue ? stage3Image : '/../../../../../../assets/images/hitmaker/3_Filming.jpg'" width="100%">
                            <span class="numberCircle">3</span>                       

                        </a>
                         
                </div>
                <div class="card-status-div">
                    <span style="font-style: 'Lato';">
                        {{ filmingStatus }}
                    </span>
                </div>
            </div>
    
            <div class="card" 
              appTrackClick 
                [buttonProps]="{
                    title:'hitmaker_post-production_stage',
                    feature_context:'HITMAKER'
                }"
            >                
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('post-production', $event)" style="text-decoration: none;">
                        <span style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Post-Production</span>
                        <br>
                        <span style="color: white;font-size: 14px;
                        padding-left: 10px;
                        padding-right: 10px;">Help  pick the film<br> score and more !</span>
                    </a>
                </div>
                <div class="card-img-div" (click)="getStageDetails('post-production', $event)">
                    
                        <a href="">
                            <img class="card-content" height="100%" [src]="showPostProductionThumbnailValue ? stage4Image : '/../../../../../../assets/images/hitmaker/4_PostProduction.jpg'" width="100%">
                            <span class="numberCircle">4</span>                       

                        </a>
                        
                </div>
                <div class="card-status-div">
                    <span style="font-style: 'Lato';">
                        {{ postProductionStatus }}
                    </span>
                </div>
            </div>
    
            <div class="card"
            appTrackClick 
            [buttonProps]="{
                title:'hitmaker_release_stage',
                feature_context:'HITMAKER'
            }"
            >
                <div class="card-text-div">
                    <a class="card-text" href=""  (click)="getStageDetails('release', $event)" style="text-decoration: none;">
                        <span  style="color: white;font-size: 18px;
                        padding-left: 10px;
                        padding-right: 10px;">Release</span>
                        <br>
                        <span  style="color: white;font-size: 14px;
                        padding-left: 10px;
                        padding-right: 10px;">Culiminate the journey<br> with special access!</span>
                    </a>
                </div>
                <div class="card-img-div"  (click)="getStageDetails('release', $event)">
                    
                        <a href="">
                            <img class="card-content" height="100%" [src]="showReleaseThumbnailValue ? stage5Image : '/../../../../../../assets/images/hitmaker/5_Release.jpg'" width="100%">
                            <span class="numberCircle">5</span>                       

                        </a>
                        
                </div>
                <div class="card-status-div">
                    <span style="font-style: 'Lato';">
                        {{ releaseStatus }}
                    </span>
                </div>
            </div>
            
        </div>
    </div>

    <br>
</div>
</div>
